import React from 'react';
import { Shield, Clock, Home } from 'lucide-react';

export const Benefits = () => {
  return (
    <div className="py-16 bg-[#1A1F2C]/50">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl font-bold text-center text-white mb-12">
          Why Choose Our Debt Relief Solution?
        </h2>
        <div className="grid md:grid-cols-3 gap-8">
          {[
            {
              icon: <Shield className="w-12 h-12 text-primary" />,
              title: "Legal Protection",
              description: "Our expert legal team ensures your rights are protected throughout the process"
            },
            {
              icon: <Clock className="w-12 h-12 text-primary" />,
              title: "Swift Results",
              description: "See immediate relief with our efficient debt reduction process"
            },
            {
              icon: <Home className="w-12 h-12 text-primary" />,
              title: "Keep Your Assets",
              description: "Protect your home, car, and other assets while reducing your debt"
            }
          ].map((benefit, index) => (
            <div key={index} className="text-center p-6 rounded-xl bg-white/5 backdrop-blur-sm border border-white/10">
              <div className="flex justify-center mb-4">{benefit.icon}</div>
              <h3 className="text-xl font-semibold text-white mb-2">{benefit.title}</h3>
              <p className="text-gray-300">{benefit.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};